import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { isFirefox } from "@faire/retailer-visitor-shared/lib/user-agent/isFirefox";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import React from "react";
/**
 * @Todd So this is supposed to fix a bug with how firefox renders img tags before they are mounted,
 * in firefox it renders the alt text before showing the image, and we want to hide that
 * except for when its a google bot because otherwise you will see a flash of alt text while its loading
 * and it looks bad
 */ var hiddenAltText = function() {
    var backgroundColor = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "white";
    var _getWindow;
    return isFirefox() && !((_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.isRobot) ? {
        color: backgroundColor,
        backgroundColor: backgroundColor
    } : {};
};
export var Image = function(_param) {
    var ref = _param.ref, placeholderColor = _param.placeholderColor, style = _param.style, rest = _object_without_properties(_param, [
        "ref",
        "placeholderColor",
        "style"
    ]);
    var _ref = style !== null && style !== void 0 ? style : {}, backgroundColor = _ref.backgroundColor, restStyle = _object_without_properties(_ref, [
        "backgroundColor"
    ]);
    return /*#__PURE__*/ _jsx("img", _object_spread_props(_object_spread({}, rest), {
        style: _object_spread({}, hiddenAltText(backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : placeholderColor), restStyle),
        ref: ref
    }));
};
